import NoImage from "../../assets/images/No_Image_Available.jpg";
import LazyImage from "../image/LazyLoadImage";


const ProgrammeComponent = ({program}) => {
  return (
    <div className="cursor-pointer">
      <div>
        <div className="h-[280px] relative">
          {/* <LazyImage src={program?.displayImage ?? NoImage} className="w-full h-full object-cover rounded-lg shadow-md" /> */}
          <img
            src={program?.displayImage ?? NoImage}
            alt="event"
            className="w-full h-full object-cover rounded-lg shadow-md"
          />
        </div>
        <div className="px-3 my-16">
          <div className="font-bold">{program?.name}</div>
          <div className="text-[1.2rem] py-1">
            <>
              {new Date(program?.startDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}{" "}
              -{" "}
              {new Date(program?.endDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgrammeComponent;
